/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import _ from 'lodash';
import clsx from 'clsx';
import InputAdornment from '@mui/material/InputAdornment';
import { EditorState, Modifier, SelectionState } from 'draft-js';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CheckBoxComponent from '../../../../SharedModules/CheckBox/CheckBox';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import LTCommonModal from './gridComponents/LTCommonModal';
import {
  contactAddress,
  contactAddressExists,
  maintainLetterTemplate,
} from './gridComponents/ConstantData';
import PDFExportPanel from '../../../../SharedModules/pdfExport/PDFExportPanel';
import {
  TEMPLATE_TYPE_REQUIRED,
  WINDOW_VALIDATION,
  AUTO_SEND_IND_FOR_DISPUTE,
  EMAIL_SUBJECT_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  getRandomNumberByInput,
  convertBlockmaptoHTML,
  convertHTMLtoBlockmap,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  saveLetterTemplateErrorMsgList,
  getWindowAddrPos,
  saveLetterTemplateDetailList,
  setExtraStateFromOther,
  getAutoSendIndicatorValidation,
  getAllSubMergeFieldListData,
} from '../store/actions';

const WINDOW_ADDRESS_DEFAULT_HEADER_LIMITATION =
  'Window Address cannot be enabled when Default Header merge fields are present for Collection templates.';

function LTDetailTab(props) {
  const {
    isEnableSave,
    isSaveOpen,
    isEnableCancel,
    isCancelOpen,
    isEnablebyRole,
  } = props;
  const dispatch = useDispatch();

  const errorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages
  );
  const detailTabErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.detailTab
  );
  const detailPageErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.detailPage
  );
  const letterTemplateDetail = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.letterTemplateDetail
  );
  const letterTemplateDetailPage = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.letterTemplateDetail.searchValue
  );
  const autoSendIndValid = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.autoSendIndValid
  );
  const generalSystemParameter = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.generalSystemParameter
  );
  const allMergeFieldList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.allMergeFieldList
  );

  const getSubMergeFieldList = (value) =>
    dispatch(getAllSubMergeFieldListData(value));

  const insertTextAtLine = React.useCallback(
    (editorState, text, lineIndex) => {
      if (!editorState || !editorState.getCurrentContent) {
        return editorState;
      }
      let content = editorState.getCurrentContent();
      let blocks = content.getBlockMap().toList();

      // Ensure at least lineIndex + 1 blocks
      while (blocks.size < lineIndex + 1) {
        const lastBlock = blocks.last();
        const selectionToEnd = SelectionState.createEmpty(
          lastBlock.getKey()
        ).merge({
          anchorOffset: lastBlock.getLength(),
          focusOffset: lastBlock.getLength(),
        });
        content = Modifier.splitBlock(content, selectionToEnd);
        blocks = content.getBlockMap().toList();
      }

      const targetBlock = blocks.get(lineIndex);
      const selectionToTarget = SelectionState.createEmpty(
        targetBlock.getKey()
      ).merge({
        anchorOffset: 0,
        focusOffset: 0,
      });

      content = Modifier.insertText(content, selectionToTarget, text);

      // Set Left Alignment
      const currentData = targetBlock.getData();
      const newData = currentData.merge({ 'text-align': 'left' });
      content = Modifier.setBlockData(content, selectionToTarget, newData);

      return EditorState.push(editorState, content, 'insert-characters');
    },
    []
  );

  const [loading, setLoading] = useState(true);
  const [viewWindowAddress, setViewWindowAddress] = useState(false);
  const [selectedTemplateList, setSelectedTemplateList] = useState(null);
  const [deliveryMediumList, setDeliveryMediumList] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(null);
  const [errorModalTitle, setErrorModalTitle] = useState('Warning');
  const [filterValue, setSetFilterValue] = useState({
    mediaCd: 'Print_Mail',
    windowAddrInd: false,
    windowAddrPos: null,
    autoSendInd: false,
    usedInd: false,
    includeWithInvoiceInd: false,
    defResponseDueInterval: null,
    contactTypeCd: null,
    emailSubject: null,
    recipientTypeCd: null,
  });
  const setStateChange = (val) => {
    dispatch(
      setExtraStateFromOther({
        ...val,
        ...(val?.edit === true ? { disableSave: false } : {}),
      })
    );
  };

  // This run when error msg change and save in redux
  const setErrorStateChange = (val) => {
    dispatch(
      saveLetterTemplateErrorMsgList({
        ...errorMessages,
        ...val,
      })
    );
  };

  React.useEffect(() => {
    if (
      letterTemplateDetailPage?.rebateProgramCd &&
      letterTemplateDetailPage?.templateTypeCd === 'DISPUTE'
    ) {
      dispatch(
        getAutoSendIndicatorValidation({
          rebateProgramCd: letterTemplateDetailPage.rebateProgramCd,
          templateTypeCd: [letterTemplateDetailPage.templateTypeCd],
        })
      );
    }
  }, [
    dispatch,
    letterTemplateDetailPage?.rebateProgramCd,
    letterTemplateDetailPage?.templateTypeCd,
  ]);

  // This just get new update data from redux to useState
  React.useEffect(() => {
    setLoading(false);
    if (letterTemplateDetailPage && !_.isEmpty(letterTemplateDetailPage)) {
      setSetFilterValue(letterTemplateDetailPage);
      let disabled = false;
      if (letterTemplateDetailPage?.templateTypeCd === 'COVER') {
        disabled = true;
      }
      const list = [
        { name: 'Print/Mail Only', value: 'PRINT', disabled: false },
        { name: 'Email Only', value: 'EMAIL', disabled: disabled },
        { name: 'Either (try Email first)', value: 'BOTH', disabled: disabled },
      ];
      setDeliveryMediumList(list);
    }
  }, [letterTemplateDetailPage]);

  const filterAction = React.useCallback(
    async (flType, value) => {
      const curData = { ...letterTemplateDetailPage };
      // let newVal = value;
      let errorMsg1 = detailTabErrorMessages;
      if (!_.isEmpty(errorMsg1)) {
        errorMsg1 = _.filter(
          detailTabErrorMessages,
          (l) => l.id !== 'sucessMsg'
        );
      }

      const errorMsg = !_.isEmpty(detailPageErrorMessages)
        ? _.filter(
            detailPageErrorMessages,
            (l) => !_.includes(['sucessMsg'], l.id)
          )
        : [];
      curData[flType] = value;
      if (
        flType === 'autoSendInd' &&
        letterTemplateDetailPage?.templateTypeCd === 'DISPUTE'
      ) {
        if (
          autoSendIndValid &&
          value === 1 &&
          letterTemplateDetail.detail.autoSendInd === 0
        ) {
          // newVal = 0;
          curData.autoSendInd = false;
          setIsError(true);
          setIsErrorMsg(AUTO_SEND_IND_FOR_DISPUTE);
          setErrorModalTitle('Warning');
        } else {
          setStateChange({ edit: true });
        }
      } else {
        if (flType === 'mediaCd') {
          errorMsg1 = !_.isEmpty(detailTabErrorMessages)
            ? _.filter(detailTabErrorMessages, (l) => l.id !== 'emailSubject')
            : [];
        }
        if (flType === 'windowAddrInd') {
          const getText = (content) => {
            if (
              content &&
              typeof content === 'object' &&
              content.getCurrentContent
            ) {
              return content.getCurrentContent().getPlainText();
            }
            return content || '';
          };

          const body = getText(letterTemplateDetailPage.body);
          const header = getText(letterTemplateDetailPage.header);
          const footer = getText(letterTemplateDetailPage.footer);

          const hasContactAddress =
            body.toUpperCase().includes(contactAddress) ||
            header.toUpperCase().includes(contactAddress) ||
            footer.toUpperCase().includes(contactAddress);
          const currentTemplateDetails = !_.isEmpty(
            letterTemplateDetail?.templateDetails
          )
            ? _.cloneDeep(letterTemplateDetail.templateDetails)
            : [];
          const activeHeaderMergeFields = _.filter(
            currentTemplateDetails,
            (d) => d.page === 'header' && !d.tempDetRemoved
          );
          const hasDefaultHeaderMergeFields = _.some(
            activeHeaderMergeFields,
            (d) =>
              d.templateMetaDataSeqNum !== 6 &&
              (d.description || '').toUpperCase() !== 'CONTACT ADDRESS'
          );
          const isCollectionTemplate =
            letterTemplateDetailPage?.templateTypeCd === 'COLLECTION';

          if (value === 1 && hasContactAddress) {
            setIsError(true);
            setIsErrorMsg(contactAddressExists);
            setErrorModalTitle(maintainLetterTemplate);
            return;
          }

          if (
            value === 1 &&
            isCollectionTemplate &&
            hasDefaultHeaderMergeFields
          ) {
            setIsError(true);
            setIsErrorMsg(WINDOW_ADDRESS_DEFAULT_HEADER_LIMITATION);
            setErrorModalTitle(maintainLetterTemplate);
            return;
          }

          if (value === 1 && !hasContactAddress) {
            const windowAddrPosValue =
              curData.windowAddrPos ??
              generalSystemParameter?.defWindowAddrPos ??
              10;

            const contactAddressMergeField = !_.isEmpty(allMergeFieldList)
              ? _.find(allMergeFieldList, (mf) => mf.templateMetaDataSeqNum === 6)
              : null;

            if (contactAddressMergeField) {
              const existingCount = !_.isEmpty(currentTemplateDetails)
                ? _.filter(currentTemplateDetails, (d) => {
                    const base = (d.displayName || '').replace(/[0-9]/g, '');
                    return (
                      base === contactAddressMergeField.description &&
                      !d.tempDetRemoved
                    );
                  }).length
                : 0;

              const displayName = `${contactAddressMergeField.description}${
                existingCount + 1
              }`;

              const subMergeFieldList = await Promise.resolve(
                getSubMergeFieldList({
                  templateMetaDataSeqNum:
                    contactAddressMergeField.templateMetaDataSeqNum,
                })
              );

              const tempDatailItems = !_.isEmpty(subMergeFieldList)
                ? _.map(subMergeFieldList, (it) => ({
                    ...it,
                    isSelected: true,
                    tempdItemRemoved: false,
                  }))
                : [];

              currentTemplateDetails.push({
                ...contactAddressMergeField,
                key: getRandomNumberByInput(1)[0],
                templateDetailSeqNum: null,
                displayName,
                page: 'header',
                tempDetRemoved: false,
                tempDatailItems,
              });

              curData.header = insertTextAtLine(
                letterTemplateDetailPage.header,
                `{${displayName}} `,
                3
              );
              curData.windowAddrPos = windowAddrPosValue;

              dispatch(
                saveLetterTemplateDetailList({
                  ...letterTemplateDetail,
                  templateDetails: currentTemplateDetails,
                  searchValue: { ...curData },
                })
              );

              setErrorStateChange({
                detailPage: _.uniqBy(errorMsg, 'id'),
                detailTab: _.uniqBy(errorMsg1, 'id'),
              });

              setStateChange({ edit: true });
              return;
            }

            curData.windowAddrPos = windowAddrPosValue;
          }

          if (value === 0) {
            curData.windowAddrPos = null;
            if (!_.isEmpty(currentTemplateDetails)) {
              const contactAddressDetails = _.filter(
                currentTemplateDetails,
                (d) =>
                  d.page === 'header' &&
                  !d.tempDetRemoved &&
                  ((d.description || '').toUpperCase() === 'CONTACT ADDRESS' ||
                    d.templateMetaDataSeqNum === 6)
              );

              if (!_.isEmpty(contactAddressDetails)) {
                currentTemplateDetails.forEach((d) => {
                  const isContactAddressField =
                    d.page === 'header' &&
                    ((d.description || '').toUpperCase() ===
                      'CONTACT ADDRESS' ||
                      d.templateMetaDataSeqNum === 6);
                  if (isContactAddressField && !d.tempDetRemoved) {
                    d.tempDetRemoved = true;
                    if (!_.isEmpty(d.tempDatailItems)) {
                      d.tempDatailItems = _.map(d.tempDatailItems, (item) => ({
                        ...item,
                        tempdItemRemoved: true,
                        isSelected: false,
                      }));
                    }
                  }
                });

                const headerHtml = letterTemplateDetailPage?.header
                  ? convertBlockmaptoHTML(letterTemplateDetailPage.header)
                  : '';
                let updatedHeaderHtml = headerHtml;
                contactAddressDetails.forEach((field) => {
                  const token = `{${field.displayName}}`;
                  updatedHeaderHtml = _.replace(updatedHeaderHtml, token, '');
                });
                curData.header = convertHTMLtoBlockmap(updatedHeaderHtml);

                dispatch(
                  saveLetterTemplateDetailList({
                    ...letterTemplateDetail,
                    templateDetails: currentTemplateDetails,
                    searchValue: { ...curData },
                  })
                );

                setErrorStateChange({
                  detailPage: _.uniqBy(errorMsg, 'id'),
                  detailTab: _.uniqBy(errorMsg1, 'id'),
                });
                setStateChange({ edit: true });
                return;
              }
            }
          }

          if (curData.windowAddrInd === 0) {
            errorMsg1 = !_.isEmpty(errorMsg1)
              ? _.filter(errorMsg1, (l) => l.id !== 'windowAddrPos')
              : [];
          }
        }
        setStateChange({ edit: true });
      }
      dispatch(
        saveLetterTemplateDetailList({
          ...letterTemplateDetail,
          searchValue: { ...curData },
        })
      );
      setErrorStateChange({
        detailPage: _.uniqBy(errorMsg, 'id'),
        detailTab: _.uniqBy(errorMsg1, 'id'),
      });
      // setErrorStateChange({ detailTab: _.uniqBy(errorMsg1, 'id') });
    },
    [
      letterTemplateDetail,
      letterTemplateDetailPage,
      autoSendIndValid,
      allMergeFieldList,
      generalSystemParameter,
    ]
  );

  const onBlurAction = (flType, value) => {
    let flId = flType;
    if (flType === 'mediaCd') {
      flId = 'emailSubject';
    }
    if (flType === 'windowAddrInd') {
      flId = 'windowAddrPos';
    }
    let newValue = value;
    const errorMsg1 = !_.isEmpty(detailTabErrorMessages)
      ? _.filter(
          detailTabErrorMessages,
          (l) => !_.includes(['sucessMsg', flId], l.id)
        )
      : [];
    const errorMsg = !_.isEmpty(detailPageErrorMessages)
      ? _.filter(
          detailPageErrorMessages,
          (l) => !_.includes(['sucessMsg'], l.id)
        )
      : [];
    if (flType === 'windowAddrPos') {
      const rg = /^-?[0-9]*$/;
      if (!value || value === '' || !rg.test(value)) {
        newValue = null;
        errorMsg1.push({ id: flType, message: WINDOW_VALIDATION });
      }
    }
    if (flType === 'emailSubject') {
      if (letterTemplateDetailPage.mediaCd !== 'PRINT') {
        if (_.isNull(value) || _.isNaN(value) || value === '') {
          errorMsg1.push({ id: flType, message: EMAIL_SUBJECT_REQUIRED });
        }
      }
    }
    filterAction(flType, newValue);
    setErrorStateChange({
      detailPage: _.uniqBy(errorMsg, 'id'),
      detailTab: _.uniqBy(errorMsg1, 'id'),
    });
  };

  const onClickViewWindowAddress = () => {
    setLoading(true);
    dispatch(getWindowAddrPos({}));
    setViewWindowAddress(true);
  };

  const copyWindowPosition = (flType, row) => {
    const errorMsg1 = !_.isEmpty(detailTabErrorMessages)
      ? _.filter(detailTabErrorMessages, (l) => l.id !== 'windowAddrPos')
      : [];
    let value = null;
    let modalView = true;
    if (flType === 'default') {
      const data =
        generalSystemParameter && !_.isEmpty(generalSystemParameter)
          ? generalSystemParameter.defWindowAddrPos
          : 0;
      value = data;
      modalView = false;
    } else if (row && !_.isEmpty(row)) {
      value = row.windowAddrPos;
      modalView = false;
    } else {
      errorMsg1.push({ id: 'windowAddrPos', message: WINDOW_VALIDATION });
      setIsErrorMsg(TEMPLATE_TYPE_REQUIRED);
      setIsError(true);
      setErrorModalTitle('Warning');
    }
    filterAction('windowAddrPos', value);
    setViewWindowAddress(modalView);
    setErrorStateChange({ detailTab: _.uniqBy(errorMsg1, 'id') });
  };

  const onChangeFilter = (flType, value) => {
    setSetFilterValue({
      ...filterValue,
      [flType]: value,
    });
  };

  return (
    <div
      className="frr-lettterTemplate-detail-tab mt-4"
      data-testid="letter-template-detail-tab-component"
    >
      <Spinner load={loading} />
      {/* <DisplayErrorMessages
        data-testid="letter-template-error-msg-comp"
        errorMessages={
          detailTabErrorMessages
            ? _.map(detailTabErrorMessages, (l) => l.message)
            : []
        }
      /> */}
      <div className="row">
        <div className="col-6 mb-3 col-sm-5 col-md-6 col-lg-6">
          <RadioGroupComponent
            data-testid="delivery-medium-redio-btn"
            id="action-radio-btn-action"
            labelName="Delivery Medium"
            required={false}
            optionList={deliveryMediumList || []}
            defaultValue={filterValue.mediaCd}
            filterAction={(e) => {
              if (isEnablebyRole) {
                filterAction('mediaCd', e);
              }
            }}
            disabled={!isEnablebyRole}
            className="log-batch-filter-radio"
          />
        </div>

        <div className="col-3">
          <CheckBoxComponent
            className="pt-10 w-100 border-0 no-wrap"
            data-testid="window-address-check"
            labelName="Window Address"
            defaultValue={filterValue.windowAddrInd === 1}
            filterAction={(e) => {
              if (isEnablebyRole) {
                filterAction(
                  'windowAddrInd',
                  filterValue.windowAddrInd === 1 ? 0 : 1
                );
              }
            }}
            disabled={!isEnablebyRole}
          />
          <SelectBoxWithoutBoxComponent
            data-testid="window-position-input"
            labelName="Window Position"
            required
            disabled={filterValue.windowAddrInd !== 1 || !isEnablebyRole}
            select={false}
            className="p-0"
            className1="no-margin"
            inputProps={{ maxlength: 99 }}
            InputProps={{
              endAdornment: filterValue.windowAddrInd === 1 && (
                <InputAdornment position="end" className="prefix-symbol">
                  <div className="th-icon ic-actions">
                    <PDFExportPanel
                      data-testid="window-position-input-dropdown"
                      isExport={false}
                      addRowsView
                      addRowsTitle="Default Window Address Position"
                      onClickAddNdC={() => copyWindowPosition('default', 3)}
                      viewCopyPage="Copy Window Address Position"
                      viewCopyPageAction={onClickViewWindowAddress}
                      isEnablebyRole={isEnablebyRole}
                    />
                  </div>
                </InputAdornment>
              ),
            }}
            defaultValue={
              filterValue.windowAddrPos === 0
                ? 0
                : filterValue.windowAddrPos
                ? filterValue.windowAddrPos
                : ''
            }
            filterAction={(e) => {
              const rg = /^-?[0-9]*$/;
              const newNo = _.toNumber(e);
              if (
                ((rg.test(e) && _.isNaN(newNo)) ||
                (_.lte(newNo, 99) && _.gte(newNo, -99))) &&
                isEnablebyRole
              ) {
                setStateChange({ edit: true });
                onChangeFilter('windowAddrPos', e);
              }
            }}
            onBlurAction={(e) => {
              if (isEnablebyRole) {
                onBlurAction('windowAddrPos', e);
              }
            }}
            isError={
              !_.isEmpty(detailTabErrorMessages)
                ? _.filter(
                    detailTabErrorMessages,
                    (l) => l.id === 'windowAddrPos'
                  ).length
                  ? _.filter(
                      detailTabErrorMessages,
                      (l) => l.id === 'windowAddrPos'
                    )[0].message
                  : null
                : null
            }
          />
        </div>

        <div className="col-3 col-sm-4 col-md-3 col-lg-3">
          <CheckBoxComponent
            className={clsx(
              'py-0 w-100 border-0',
              letterTemplateDetailPage?.templateTypeCd === 'COVER' &&
                'frr-disable-checkbox'
            )}
            data-testid="auto-send-check"
            labelName="Auto Send"
            disabled={
              letterTemplateDetailPage
                ? letterTemplateDetailPage?.templateTypeCd === 'COVER' ||
                  !isEnablebyRole
                : !isEnablebyRole
            }
            defaultValue={filterValue.autoSendInd === 1}
            filterAction={(e) => {
              if (isEnablebyRole) {
                filterAction('autoSendInd', filterValue.autoSendInd === 1 ? 0 : 1);
              }
            }}
          />

          <CheckBoxComponent
            className="py-0 w-100 border-0 frr-disable-checkbox"
            data-testid="used-indicator-check"
            labelName="Used Indicator"
            disabled
            defaultValue={filterValue.usedInd === 1}
            filterAction={(e) =>
              filterAction('usedInd', filterValue.usedInd === 1 ? 0 : 1)
            }
          />

          <CheckBoxComponent
            className="py-0 w-100 border-0 frr-disable-checkbox"
            data-testid="include-with-invoice-check"
            labelName="Include With Invoice"
            disabled
            defaultValue={filterValue.includeWithInvoiceInd === 1}
            filterAction={(e) =>
              filterAction(
                'includeWithInvoiceInd',
                filterValue.includeWithInvoiceInd === 1 ? 0 : 1
              )
            }
          />
        </div>

        <div className="col-3 col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <SelectBoxWithoutBoxComponent
            data-testid="default-response-due-interval-input"
            labelName="Default Response Due Interval"
            required={false}
            disabled={
              letterTemplateDetailPage?.templateTypeCd === 'COVER' ||
              !isEnablebyRole || false
            }
            select={false}
            inputProps={{ maxlength: 3 }}
            defaultValue={filterValue.defResponseDueInterval}
            filterAction={(e) => {
              const rg = /^[0-9]*$/;
              if (rg.test(e) && isEnablebyRole) {
                setStateChange({ edit: true });
                onChangeFilter('defResponseDueInterval', e);
              }
            }}
            onBlurAction={(e) => {
              if (isEnablebyRole) {
                onBlurAction('defResponseDueInterval', e);
              }
            }}
            isError={
              !_.isEmpty(detailTabErrorMessages) &&
              _.filter(
                detailTabErrorMessages,
                (l) => l.id === 'defResponseDueInterval'
              ).length
            }
          />
        </div>

        <div className="col-3 col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <SelectBoxWithoutBoxComponent
            data-testid="contact-type-input"
            labelName="Contact Type"
            required={false}
            disabled={!isEnablebyRole }
            select
            selectedOne={false}
            optionList={[
              { id: 'INV', name: 'Invoice Contact from Contract' },
              { id: 'DISP', name: 'Dispute Contact from Contract' },
            ]}
            defaultValue={filterValue.contactTypeCd}
            filterAction={(e) => {
              if (isEnablebyRole) {
                filterAction('contactTypeCd', e);
              }
            }}
            isError={
              !_.isEmpty(detailTabErrorMessages) &&
              _.filter(detailTabErrorMessages, (l) => l.id === 'contactTypeCd')
                .length
            }
          />
        </div>

        <div className="col-3 col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <SelectBoxWithoutBoxComponent
            data-testid="email-subject-input"
            labelName="Email Subject"
            required={filterValue.mediaCd !== 'PRINT' || false}
            disabled={!isEnablebyRole}
            select={false}
            inputProps={{ maxlength: 100 }}
            defaultValue={filterValue.emailSubject || ''}
            filterAction={(e) => {
              if (isEnablebyRole) {
                setStateChange({ edit: true });
                onChangeFilter('emailSubject', e);
              }
            }}
            onBlurAction={(e) => {
              if (isEnablebyRole) {
                onBlurAction('emailSubject', e);
              }
            }}
            isError={
              !_.isEmpty(detailTabErrorMessages) &&
              _.filter(detailTabErrorMessages, (l) => l.id === 'emailSubject')
                .length
            }
          />
        </div>

        <div className="col-3 col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <SelectBoxWithoutBoxComponent
            data-testid="recipient-type-input"
            labelName="Recipient Type"
            required={false}
            disabled
            select={false}
            inputProps={{ maxlength: 100 }}
            defaultValue={filterValue.recipientTypeCd}
            filterAction={(e) => filterAction('recipientTypeCd', e)}
          />
        </div>
      </div>

      {viewWindowAddress && (
        <CommonModal
          data-testid="detail-tabs-common-modal"
          className="dialog-900"
          open={viewWindowAddress}
          viewAction
          viewHeader
          onOk={() => copyWindowPosition('selected', selectedTemplateList)}
          okTitle="Ok"
          onClose={() => setViewWindowAddress(false)}
          closeTitle="Close"
          modalTitle="Copy Window Address Position"
          childrenComponent={
            <LTCommonModal
              closeModal={setViewWindowAddress}
              setLoading={setLoading}
              pageView="windowPosition"
              onSelectRow={setSelectedTemplateList}
            />
          }
        />
      )}

      {isError && (
        <CommonModal
          data-testid="detail-tabs-common-error-modal"
          className="dialog-420"
          open={isError}
          viewAction
          viewHeader
          onClose={() => setIsError(false)}
          closeTitle="Ok"
          //modalTitle="Warning"
          modalTitle={errorModalTitle}
          childrenComponent={<div className="p-3">{isErrorMsg}</div>}
        />
      )}
    </div>
  );
}

export default LTDetailTab;
